export const COLORS = {
    dark: '#39363a',
    white: '#ffffff',

    primary: '#47a2ff',
    primaryHover: '#2f89e5',
    primary100: '#edf6ff',
    primary200: '#daecff',
    primary300: '#b5daff',

    grey100: '#f4f4f8',
    grey200: '#e1e7ee',
    grey300: '#d1d8e1',
    grey400: '#94a0b1',

    success: '#2bd16d',
    alert: '#f25248',
    alert100: '#FFE5DC',
    warning: '#ffa14a',
};

export const SPACING = {
    containerPaddingHorizontal: 16,
    containerPaddingVertical: 40,
};
